import { createGlobalStyle } from 'styled-components'

// import fonts from './fonts';

export const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
    height: 100vh;
    max-height: -webkit-fill-available;
    width: 100vw;
    background-color: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Adobe Caslon Pro', verdana, sans-serif;
    font-weight: 100;
  }

  body,
  p,
  a,
  button,
  ul,
  form {
    font-family: 'Adobe Caslon Pro', verdana, sans-serif;
    font-weight: normal;
  }

  // span {
  //   font-family: inherit;
  //   font-weight: inherit;
  // }

  a {
    color: inherit;
    text-decoration: none;
    &.underline {
      text-decoration: underline;
    }
  }

  .center {
    text-align: center;
  }

  .uppercase {
    text-transform: uppercase;
  }

  .italics {
    font-style: italic;
  }
`
